.p{justify-content:center;}